import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_TRADE_ADMIN_DATE_TYPE_FILTER,
  DEFAULT_TRADE_ADMIN_SORT_MODEL,
  DEFAULT_TRADE_ADMIN_STATUS_FILTERS,
  DEFAULT_TRADE_ADMIN_TRADE_TYPE_FILTERS
} from "../../util/filterTrades";

const initialState = {
  dateTypeFilter: DEFAULT_TRADE_ADMIN_DATE_TYPE_FILTER,
  startDateFilter: null,
  endDateFilter: null,
  tradeTypeFilters: DEFAULT_TRADE_ADMIN_TRADE_TYPE_FILTERS,
  statusFilters: DEFAULT_TRADE_ADMIN_STATUS_FILTERS,
  searchString: "",
  tradeFoundByReferenceNumberSearch: null,
  tradeFoundByReferenceNumberSearchIsLoading: false,
  tradeFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  sortModel: DEFAULT_TRADE_ADMIN_SORT_MODEL,
};

// The plan is that this slice will be the home of all trade related data in the client
// including the following:
//      - trade filter metadata
//      - trade list (future)
//      - filtered trade list (future)
//      - searched trade list (future)
export const adminTradeSlice = createSlice({
  name: "adminTrade",
  initialState,
  reducers: {
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateTradeTypeFilters: (state, action) => {
      state.tradeTypeFilters = action.payload;
    },
    updateStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateTradeFoundByReferenceNumberSearch: (state, action) => {
      state.tradeFoundByReferenceNumberSearch = action.payload;
    },
    updateTradeFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.tradeFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateTradeFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.tradeFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearAllTradeFilters: () => initialState,
  },
});

export const {
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateTradeTypeFilters,
  updateStatusFilters,
  updateSearchString,
  updateTradeFoundByReferenceNumberSearch,
  updateTradeFoundByReferenceNumberSearchIsLoading,
  updateTradeFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  clearAllTradeFilters,
} = adminTradeSlice.actions;

export const selectAdminTradeData = (state) => state.adminTrade;

export default adminTradeSlice.reducer;
